"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _acceptedPaymentMethods = _interopRequireDefault(require("@flowio/accepted-payment-methods"));

var _browserHelpers = require("@flowio/browser-helpers");

var _utilities = require("../utilities");

var _dropdown_component = _interopRequireDefault(require("../dropdown_component"));

var _countryPickerModal = _interopRequireDefault(require("../modal/country-picker-modal"));

// @ts-check

/* eslint-disable max-len */

/** @typedef {import('../types').CountryOption} CountryOption */

/** @typedef {import('../types').DropdownOptions} DropdownOptions */

/** @typedef {import('../types').DropdownOptionConfig} DropdownOptionConfig */

/** @typedef {import('../types').CountryPickerOptions} CountryPickerOptions */

/** @typedef {import('../types').AdvancedCountryPickerSelections} AdvancedCountryPickerSelections */

/** @typedef {import('../types').AdvancedCountryPickerState} AdvancedCountryPickerState */

/** @typedef {io.flow.session.v0.unions.Session} Session */

/** @typedef {io.flow.internal.v0.models.CountryPickerCountry} CountryPickerCountry */

/** @typedef {io.flow.internal.v0.models.CountryPickerCurrency} CountryPickerCurrency */

/** @typedef {io.flow.internal.v0.models.CountryPickerData} CountryPickerData */

/** @typedef {io.flow.internal.v0.models.BrowserBundle} BrowserBundle */

/* eslint-enable max-len */
var acceptedPaymentMethods = new _acceptedPaymentMethods["default"]();

var CountryPickerAdvanced = /*#__PURE__*/function (_CountryPickerModal) {
  (0, _inherits2["default"])(CountryPickerAdvanced, _CountryPickerModal);

  var _super = (0, _createSuper2["default"])(CountryPickerAdvanced);

  function CountryPickerAdvanced() {
    var _this;

    (0, _classCallCheck2["default"])(this, CountryPickerAdvanced);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "currentCountry", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "currentCurrency", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "countryPickerTrigger", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "currencyPickerTrigger", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "countryPickerMenu", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "currencyPickerMenu", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "extraMessagingContainer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "paymentMethodsElement", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "extraMessage", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deliveryWindowsElement", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "shippingTier", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selections", {
      country: undefined,
      currency: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "session", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "countryPickerBundleData", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      countryPickerOpen: false,
      currencyPickerOpen: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "countries", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeActiveDropdown", function () {
      if (!_this.state.countryPickerOpen && !_this.state.currencyPickerOpen) return;
      var isCountry = _this.state.countryPickerOpen;
      var menu = isCountry ? _this.countryPickerMenu : _this.currencyPickerMenu;
      (0, _browserHelpers.removeClass)(menu, 'flow-country-picker-show');
      (0, _browserHelpers.removeClass)(_this.modalTrigger, 'flow-country-picker-open');
      (0, _browserHelpers.removeEvent)(_this.backdrop, 'click', _this.closeActiveDropdown);
      _this.state[isCountry ? 'countryPickerOpen' : 'currencyPickerOpen'] = false;
      (0, _browserHelpers.removeEvent)(_this.ddBackdrop, 'click', _this.closeActiveDropdown);

      _this.ddBackdrop.parentElement.removeChild(_this.ddBackdrop);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openDropdown", function (event) {
      var isCountry = /\bflow-country-/.test(event.currentTarget.className);
      var menu = isCountry ? _this.countryPickerMenu : _this.currencyPickerMenu;
      (0, _browserHelpers.addClass)(menu, 'flow-country-picker-show');
      (0, _browserHelpers.addClass)(_this.modalTrigger, 'flow-country-picker-open');
      (0, _browserHelpers.addEvent)(_this.backdrop, 'click', _this.closeActiveDropdown);
      _this.ddBackdrop = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-dropdown-backdrop',
        id: 'countryPickerBackdrop'
      });
      (0, _browserHelpers.addEvent)(_this.ddBackdrop, 'click', _this.closeActiveDropdown);

      _this.modal.appendChild(_this.ddBackdrop);

      _this.state[isCountry ? 'countryPickerOpen' : 'currencyPickerOpen'] = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateSelectedMenuItems", function () {
      var countryMenu = _this.countryPickerMenu;
      var currencyMenu = _this.currencyPickerMenu;
      var countryCheck = countryMenu.getElementsByClassName('svg-check');

      if (countryCheck.length) {
        countryCheck[0].parentElement.removeChild(countryCheck[0]);
      }

      var currencyCheck = currencyMenu.getElementsByClassName('svg-check');

      if (currencyCheck.length) {
        currencyCheck[0].parentElement.removeChild(currencyCheck[0]);
      }

      CountryPickerAdvanced.updateSelectedMenuItem(countryMenu, _this.selections.country);
      CountryPickerAdvanced.updateSelectedMenuItem(currencyMenu, _this.selections.currency);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNewMessageText", function (country, currency) {
      _this.extraMessage.innerHTML = _this.options.extraMessagingString.replace('{country}', country).replace('{currency}', currency);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNewDeliveryWindows", function (deliveryWindows) {
      if (_this.deliveryWindowsElement) {
        if (deliveryWindows[0]) {
          var localeString = navigator.language;
          var options = {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          };
          var startDate = new Date(deliveryWindows[0].from).toLocaleDateString(localeString, options);
          var endDate = new Date(deliveryWindows[0].to).toLocaleDateString(localeString, options);
          _this.deliveryWindowsElement.innerHTML = "<b>Delivery Window</b> ".concat(startDate, " - ").concat(endDate);
        } else {
          _this.deliveryWindowsElement.innerHTML = '';
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNewShippingTier", function (shippingTier) {
      if (_this.shippingTier) {
        if (shippingTier) {
          _this.shippingTier.innerHTML = shippingTier;
        } else {
          _this.shippingTier.innerHTML = '';
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setNewPaymentMethods", function (paymentMethods) {
      if (_this.paymentMethodsElement) {
        _this.paymentMethodsElement.innerHTML = '';

        if (paymentMethods) {
          acceptedPaymentMethods.forceRender({
            paymentMethods: paymentMethods,
            mountNodes: [_this.paymentMethodsElement]
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearDeliveryWindowElements", function () {
      if (_this.deliveryWindowsElement) _this.deliveryWindowsElement.innerHTML = '';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearPaymentMethodsElement", function () {
      if (_this.paymentMethodsElement) _this.paymentMethodsElement.innerHTML = '';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearExtraMessagingElements", function () {
      if (_this.paymentMethodsElement) _this.paymentMethodsElement.innerHTML = '';
      if (_this.deliveryWindowsElement) _this.deliveryWindowsElement.innerHTML = '';
      if (_this.shippingTier) _this.shippingTier.innerHTML = '';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateExtraInformation", function (status, session) {
      if (session) {
        if (_this.options.enableCurrencyDropdown) {
          _this.setNewMessageText(session.geo.country.name, _this.selections.currency);
        } else {
          _this.setNewMessageText(session.geo.country.name, session.geo.currency.iso_4217_3);
        } // Replace this with browser bundle when the data is there


        if (session.experience) {
          var paymentMethods = _this.countryPickerBundleData.experience_data.find(function (data) {
            return data.experience_key === session.experience.key;
          });

          var deliveryWindows = _this.countryPickerBundleData.country_data.find(function (data) {
            return data.country === session.geo.country.iso_3166_3;
          });

          if (paymentMethods) {
            _this.setNewPaymentMethods(paymentMethods.payment_methods);
          } else {
            _this.clearPaymentMethodsElement();
          }

          if (deliveryWindows) {
            _this.setNewDeliveryWindows(deliveryWindows.delivery_window);
          } else {
            _this.clearDeliveryWindowElements();
          }
        } else {
          _this.clearExtraMessagingElements();
        }
      } else {
        _this.setNewMessageText(_this.selections.country, _this.selections.currency);

        _this.clearExtraMessagingElements();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "generateModalOptions", function (options) {
      var countries = options.countries,
          _options$currencies = options.currencies,
          currencies = _options$currencies === void 0 ? [] : _options$currencies;
      _this.countries = countries;
      var modalBody = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal-body'
      });
      var modalBodyContent = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal-body-content'
      });
      var hasLanded = localStorage.getItem('_f60_landed');
      /** @type {import('../types').DropdownOptionsKeyValueMap} */

      var countryOptionsMap = {};
      countries.forEach(
      /** @type {(country: CountryPickerCountry) => void} */
      function (country) {
        countryOptionsMap[country.iso_3166_3] =
        /** @type {DropdownOptionConfig} */
        {
          label: "".concat(country.name),
          iso_3166_2: country.iso_3166_2
        };
      });
      /** @type {DropdownOptions} */

      var countryDropdownOptions = {
        title: 'Select Country',
        options: countryOptionsMap,
        selectedKey: _this.selections.country,
        logo: _this.options.logo,
        onItemSelect: function onItemSelect(_ref) {
          var value = _ref.value,
              item = _ref.item;
          var sessionUpdateForm = {
            country: value
          };

          if (_this.options.enableCurrencyDropdown) {
            sessionUpdateForm.curreny = _this.selections.currency;
          }

          _this.countryPickerTrigger.innerHTML = "\n          ".concat((0, _utilities.getCountryFlagImageHTML)(item.iso_3166_2, _this.options.logo, _this.currentCountry.name, item.imgSrc), "\n          <span class=\"flow-country-picker-dropdown-trigger-text\">").concat(item.label, "</span>\n        ");
          _this.selections.country = value;

          _this.updateSelectedMenuItems();

          _this.closeActiveDropdown();

          if (_this.options.enableExtraMessaging) {
            (0, _utilities.updateSession)(sessionUpdateForm, _this.session.id, _this.session.organization, _this.updateExtraInformation, false);
          }
        }
      };

      _dropdown_component["default"].generateDropdownOptions(countryDropdownOptions).forEach(function (ddopt) {
        return _this.countryPickerMenu.appendChild(ddopt);
      });

      if (_this.options.enableCurrencyDropdown) {
        /** @type {import('../types').DropdownOptionsKeyValueMap} */
        var currencyOptionsMap = {};
        currencies.forEach(
        /** @type {(currency: CountryPickerCurrency) => void} */
        function (currency) {
          currencyOptionsMap[currency.iso_4217_3] =
          /** @type {DropdownOptionConfig} */
          {
            label: "(".concat(currency.iso_4217_3, ") ").concat(currency.name)
          };
        });
        /** @type {DropdownOptions} */

        var currencyDropdownOptions = {
          title: 'Select Currency',
          options: currencyOptionsMap,
          selectedKey: _this.selections.currency,
          logo: false,
          // No logos for currency currently
          onItemSelect: function onItemSelect(_ref2) {
            var value = _ref2.value,
                item = _ref2.item;
            _this.currencyPickerTrigger.innerHTML = "\n          ".concat(item.imgSrc ? "<img style=\"display: inline-block\" src=\"".concat(item.imgSrc, "\" />") : '', "\n          <span class=\"flow-country-picker-dropdown-trigger-text\">").concat(item.label, "</span>\n        ");
            _this.selections.currency = value;

            _this.updateSelectedMenuItems();

            _this.closeActiveDropdown();

            var sessionUpdateForm = {
              currency: value,
              country: _this.selections.country
            };

            if (_this.options.enableExtraMessaging) {
              (0, _utilities.updateSession)(sessionUpdateForm, _this.session.id, _this.session.organization, _this.updateExtraInformation, false);
            }
          }
        };

        _dropdown_component["default"].generateDropdownOptions(currencyDropdownOptions).forEach(function (ddopt) {
          return _this.currencyPickerMenu.appendChild(ddopt);
        });

        _this.currencyPickerTrigger.innerHTML = _this.currentCurrency ? "<span class=\"flow-currency-picker-dropdown-trigger-text\">(".concat(_this.currentCurrency.iso_4217_3, ") ").concat(_this.currentCurrency.name, "</span>") : "<span class=\"flow-currency-picker-dropdown-trigger-text\">".concat(_this.currentCurrency.iso_4217_3, "</span>");
        (0, _browserHelpers.addEvent)(_this.currencyPickerTrigger, 'click', _this.openDropdown);
        modalBodyContent.appendChild(_this.currencyPickerWrapper);
      }

      _this.countryPickerTrigger.innerHTML = "\n      ".concat((0, _utilities.getCountryFlagImageHTML)(_this.currentCountry.iso_3166_2, _this.options.logo, _this.currentCountry.name, {
        imgSrc: _this.currentCountry.logoUrl
      }), "\n      <span class=\"flow-country-picker-dropdown-trigger-text\">").concat(_this.currentCountry.name, "</span>\n    ");
      (0, _browserHelpers.addEvent)(_this.countryPickerTrigger, 'click', _this.openDropdown);
      modalBodyContent.appendChild(_this.countryPickerWrapper);
      modalBody.appendChild(modalBodyContent);

      if (_this.options.enableExtraMessaging) {
        modalBody.appendChild(_this.extraMessagingContainer);
      }

      _this.generateModalButtons(modalBody);

      (0, _browserHelpers.addEvent)(_this.modalTrigger, 'click', function () {
        var isOpen = window.document.getElementsByClassName('flow-country-picker-modal-header').length > 0;

        if (isOpen) {
          _this.toggleModal(_this.currentCountry);
        } else {
          _this.toggleModal(_this.currentCountry, modalBody, _this.options.modalTitle);
        }

        _this.initialSelections = (0, _objectSpread2["default"])({}, _this.selections);
      }); // If the session experience is undefined then we know they are not in a Flow experience

      var currentExp = _this.session ? _this.session.experience : undefined; // Simply put this is just checking if we care we are in a Flow experience
      // The logic is, if we care about being on a flow experience we only
      // want to show the landing mat when a flow experience is defined.
      // By default it is set to true since that is the current functionality

      var showLandingMat = _this.options.showLandingOnNoExp ? true : !!currentExp;

      if (_this.options.isLandingMat && !hasLanded && showLandingMat) {
        _this.toggleModal(_this.currentCountry, modalBody, _this.options.modalTitle);

        localStorage.setItem('_f60_landed', JSON.stringify(true));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "submitSelection", function () {
      var sessionPutForm;

      if (_this.options.enableCurrencyDropdown) {
        sessionPutForm = _this.options.onSelection(_this.countries.find(function (country) {
          return country.iso_3166_3 === _this.selections.country;
        }), _this.selections.currency);
      } else {
        sessionPutForm = _this.options.onSelection(_this.countries.find(function (country) {
          return country.iso_3166_3 === _this.selections.country;
        }));
      }

      if (sessionPutForm) {
        if (!(_this.session && _this.session.id)) {
          console.error('You cannot use default on selection behaviour when a Flow session does not exist.');
          return;
        }

        (0, _utilities.updateSession)(sessionPutForm, _this.session.id, _this.session.organization, _this.options.onSessionUpdate);
      }

      _this.toggleModal(_this.currentCountry);
    });
    return _this;
  }

  (0, _createClass2["default"])(CountryPickerAdvanced, [{
    key: "initDomElements",
    value: function initDomElements() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(CountryPickerAdvanced.prototype), "initDomElements", this).call(this);
      this.countryPickerWrapper = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-wrapper',
        style: 'display: inline-block'
      });
      this.countryPickerTrigger = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-dropdown-trigger'
      });
      this.countryPickerMenu = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-dropdown-menu'
      });
      this.countryPickerWrapper.appendChild(this.countryPickerTrigger);
      this.countryPickerWrapper.appendChild(this.countryPickerMenu);
      this.currencyPickerWrapper = (0, _utilities.createDomElement)('div', {
        "class": 'flow-currency-picker-wrapper',
        style: 'display: inline-block'
      });
      this.currencyPickerTrigger = (0, _utilities.createDomElement)('div', {
        "class": 'flow-currency-picker-dropdown-trigger'
      });
      this.currencyPickerMenu = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-dropdown-menu'
      });

      if (this.options.enableExtraMessaging) {
        this.extraMessagingContainer = (0, _utilities.createDomElement)('div', {
          "class": 'flow-country-picker-extra-message-container'
        });
        this.extraMessage = (0, _utilities.createDomElement)('div', {
          "class": 'flow-country-picker-extra-message'
        });
        this.extraMessagingContainer.appendChild(this.extraMessage);

        if (this.options.showDeliveryWindow) {
          this.deliveryWindowsElement = (0, _utilities.createDomElement)('div', {
            "class": 'flow-country-picker-delivery-window'
          });
          this.extraMessagingContainer.appendChild(this.deliveryWindowsElement);
        }

        if (this.options.showShippingTier) {
          this.shippingTier = (0, _utilities.createDomElement)('div', {
            "class": 'flow-country-picker-shipping-tier'
          });
          this.extraMessagingContainer.appendChild(this.shippingTier);
        }

        if (this.options.showPaymentIcons) {
          // createDomElement returns SVGElement | HTMLElement
          // not sure how to make it HTMLElement in JS
          // @ts-ignore
          this.paymentMethodsElement = (0, _utilities.createDomElement)('div', {
            "class": 'flow-country-picker-payment-methods'
          });
          this.extraMessagingContainer.appendChild(this.paymentMethodsElement);
        }
      }

      this.currencyPickerWrapper.appendChild(this.currencyPickerTrigger);
      this.currencyPickerWrapper.appendChild(this.currencyPickerMenu);
    }
    /** @type {(countryPickerData: CountryPickerData) => void} */

  }, {
    key: "setUpCountryCallback",
    value: function setUpCountryCallback(countryPickerData) {
      this.countryPickerBundleData = countryPickerData;

      if (this.currentCountry.currency) {
        this.currentCurrency = (0, _find["default"])(countryPickerData.currencies, {
          iso_4217_3: this.currentCountry.currency
        });
      }

      this.generateModalOptions(countryPickerData);

      if (this.options.enableExtraMessaging) {
        this.updateExtraInformation(200, this.session);
      }
    }
  }, {
    key: "createCountryPickerModal",
    value: function createCountryPickerModal() {
      var _this2 = this;

      (0, _browserHelpers.addClass)(this.modal, 'flow-country-picker-advanced');
      this.session = JSON.parse(localStorage.getItem('_f60_session'));
      var countryPicker = document.getElementById(this.options.containerId);

      if (!countryPicker) {
        console.error('No country picker element detected');
        return Promise.reject(new Error('No country picker element detected'));
      }

      countryPicker.appendChild(this.modalTrigger);

      if (this.options.currentExperience) {
        /* currentExperience is a reference to a country picker bespoke model
         it's not equivalent to a Flow apibuilder model. The naming is kept here
         so as to be consistent with the existing API for other CP types.  */
        this.currentCountry = this.options.currentExperience;
      } else if (this.session) {
        this.currentCountry = (0, _utilities.sessionToCountryObj)(this.session);
      } else {
        this.currentCountry = {
          label: 'Select your Country & Currency'
        };
      }

      if (this.currentCountry.iso_3166_3 && this.currentCountry.currency) {
        this.selections = {
          country: this.currentCountry.iso_3166_3,
          currency: this.currentCountry.currency
        };
      }

      this.modalTrigger.innerHTML = "\n      ".concat((0, _utilities.getCountryFlagImageHTML)(this.currentCountry.iso_3166_2, this.options.logo, this.currentCountry.name, {
        imgSrc: this.currentCountry.logoUrl
      }), "\n      <span class=\"flow-country-picker-modal-trigger-text\">").concat(this.currentCountry.label ? this.currentCountry.label : this.options.labelFormatter(this.currentCountry), "</span>\n    ");
      return (0, _utilities.setUpCountries)(this.options, this.session, this.setUpCountryCallback.bind(this)).then(function () {
        return _this2;
      })["catch"](function () {});
    }
  }, {
    key: "generateModalButtons",
    value: function generateModalButtons(modalBody) {
      var _this3 = this;

      var cancelButton = (0, _utilities.createDomElement)('button', {
        "class": 'flow-country-picker-button flow-country-picker-button-secondary'
      });
      var okButton = (0, _utilities.createDomElement)('button', {
        "class": 'flow-country-picker-button flow-country-picker-button-primary'
      });
      cancelButton.innerHTML = 'Cancel';
      okButton.innerHTML = 'OK';
      var buttonWrapper = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-button-container'
      });
      buttonWrapper.appendChild(cancelButton);
      buttonWrapper.appendChild(okButton);
      (0, _browserHelpers.addEvent)(okButton, 'click', this.submitSelection);
      (0, _browserHelpers.addEvent)(cancelButton, 'click', function () {
        _this3.selections = (0, _objectSpread2["default"])({}, _this3.initialSelections);

        _this3.toggleModal(_this3.currentCountry);
      });
      modalBody.appendChild(buttonWrapper);
    }
  }], [{
    key: "create",
    // eslint-disable-next-line max-len

    /** @type {(optionsObj: CountryPickerOptions) => Promise<any>} */
    value: function create(optionsObj) {
      var instance = new CountryPickerAdvanced(optionsObj);
      instance.initDomElements();
      return instance.createCountryPickerModal();
    }
  }, {
    key: "updateSelectedMenuItem",

    /**
     *
     * @param {Element} menu
     * @param {string} selectedValue
     */
    value: function updateSelectedMenuItem(menu, selectedValue) {
      for (var i = 0; i < menu.childNodes.length; i += 1) {
        // @ts-ignore - TS checking does not like childNodes object :-\
        var val = menu.childNodes[i].getAttribute('data-value');

        if (val === selectedValue) {
          // @ts-ignore - TS checking does not like ChildNode object :-\
          // eslint-disable-next-line no-param-reassign
          menu.childNodes[i].innerHTML += _dropdown_component["default"].svgCheck;
        }
      }
    }
    /**
     *
     * @param {string} country
     * @param {string} currency
    */

  }]);
  return CountryPickerAdvanced;
}(_countryPickerModal["default"]);

exports["default"] = CountryPickerAdvanced;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/advanced/country-picker-advanced.js
// module id = 538
// module chunks = 0 1